export const formatDate = (date) => {
    if (typeof date.getMonth === 'function') {
      return date
    } else if (date) {
      const array = date.split("-");
      return new Date(parseInt(array[0]), parseInt(array[1]) - 1, parseInt(array[2]))
    }
    return "";
  }